var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabsOnboardingOpener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 593.24 238.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .03em;\n      }\n\n      .cls-2 {\n        font-size: 4.08px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #1c8af6;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        font-family: Inter-SemiBold, Inter;\n        font-variation-settings: 'wght' 600, 'slnt' 0;\n        font-weight: 600;\n      }\n\n      .cls-3 {\n        font-size: 4.08px;\n      }\n\n      .cls-5 {\n        letter-spacing: .05em;\n      }\n\n      .cls-6 {\n        stroke: #003d80;\n        stroke-width: 1.42px;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-6, .cls-7, .cls-10 {\n        stroke-linejoin: round;\n      }\n\n      .cls-11 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-7 {\n        stroke: #003c7b;\n        stroke-width: 1.44px;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-13 {\n        fill: #0e172a;\n        filter: url(#outer-glow-2);\n      }\n\n      .cls-4 {\n        fill: #4a91ff;\n        font-size: 8.83px;\n        opacity: .85;\n      }\n\n      .cls-8 {\n        stroke-dasharray: 0 0 0 1.75;\n      }\n\n      .cls-8, .cls-9 {\n        stroke: #1c8af6;\n        stroke-miterlimit: 10;\n        stroke-width: .47px;\n      }\n\n      .cls-16 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-17 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-19 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-20 {\n        opacity: .2;\n      }\n\n      .cls-21 {\n        opacity: .55;\n      }\n\n      .cls-22 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-10 {\n        stroke: #4a91ff;\n        stroke-width: 1.75px;\n      }\n\n      .cls-23 {\n        letter-spacing: 0em;\n      }\n\n      .cls-24 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        fill: #4489ef;\n      }\n\n      .cls-15 {\n        fill: #003c7b;\n      }\n\n      .cls-25 {\n        filter: url(#outer-glow-1);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4.24
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4eb2f3",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1c89f5",
    floodOpacity: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 431.57,
    y1: 77.61,
    x2: 431.57,
    y2: 180.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a91ff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a91ff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 62.82,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 114.76,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 105.53,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 85.21,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 200.97,
    cy: 105.14,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 257.43,
    cy: 126.87,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 218.91,
    cy: 124.44,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 218.91,
    cy: 112.98,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 138.64,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 51.3,
    r: 2.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "263.09 62.82 241.37 62.82 209.05 95.14 168.98 95.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "168.98 83.29 206.3 83.29 238.29 51.3 263.09 51.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "168.98 123.81 206.38 123.81 218.91 136.34 235.85 136.34 248.38 148.87 263.09 148.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "168.98 114.76 206.38 114.76 218.91 102.23 235.85 102.23 248.38 114.76 263.09 114.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 168.98,
    y1: 105.14,
    x2: 198.54,
    y2: 105.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 239.01,
    cy: 94.61,
    r: 2.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 257.43,
    cy: 75.33,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 244.48,
    cy: 75.33,
    r: 2.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 246.91,
    y1: 75.33,
    x2: 255,
    y2: 75.33
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 174.52,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 257.43,
    cy: 158.12,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 148.87,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 200.97,
    cy: 133.05,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 265.52,
    cy: 185.96,
    r: 2.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "263.09 174.52 241.37 174.52 209.05 142.2 168.98 142.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "168.98 153.98 206.3 153.98 238.29 185.96 263.09 185.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 168.98,
    y1: 133.05,
    x2: 198.54,
    y2: 133.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "218.91 136.34 240.69 158.12 255 158.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "218.91 102.23 235.92 85.21 263.09 85.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "240.7 96.35 249.88 105.53 263.09 105.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "263.09 138.64 250.1 138.64 235.9 124.44 221.34 124.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "255 126.87 249.28 126.87 235.4 112.98 221.34 112.98"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "126.81 96.92 126.81 119.18 126.81 141.44 104.78 141.44 104.78 163.7 126.81 163.7 148.71 163.7 148.71 141.44 148.71 119.18 148.71 96.92 126.81 96.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "82.88 119.18 82.88 96.92 104.78 96.92 126.81 96.92 126.81 74.54 104.78 74.54 82.88 74.54 60.85 74.54 60.85 96.92 60.85 119.18 60.85 141.44 60.85 163.7 82.88 163.7 82.88 141.44 82.88 119.18"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 284.94,
    y: 30.05,
    width: 273.54,
    height: 177.47,
    rx: 6.55,
    ry: 6.55
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(388.35 54.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 5.41,
    y: 0
  }, "ARIS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 27.48,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 30.32,
    y: 0,
    xmlSpace: "preserve"
  }, " FRANCE")), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(326.23 191.93) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2018")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(299.4 179.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 2.77,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 5.31,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 6.48,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(299.36 158.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 2.77,
    y: 0
  }, "9,"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.38,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(299.42 136.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 2.77,
    y: 0
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 5.29,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 6.46,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(297.33 114.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.73,
    y: 0
  }, "0,"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.42,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(297.39 93.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.73,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 7.33,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 8.5,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(298.13 71.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 4.73,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 6.53,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 7.61,
    y: 0
  }, "000")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(360.43 191.94) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2019")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(393.79 192.26) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(428.88 191.88) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(462.33 192.17) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2022")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(495.95 192.23) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2023")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(530.65 192.23) rotate(-30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 5.25,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.72,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 70.4,
    x2: 315.86,
    y2: 70.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 70.4,
    x2: 542.54,
    y2: 70.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 70.4,
    x2: 543.42,
    y2: 70.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 91.99,
    x2: 315.86,
    y2: 91.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 91.99,
    x2: 542.54,
    y2: 91.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 91.99,
    x2: 543.42,
    y2: 91.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 113.61,
    x2: 315.86,
    y2: 113.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 113.61,
    x2: 542.54,
    y2: 113.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 113.61,
    x2: 543.42,
    y2: 113.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 135.27,
    x2: 315.86,
    y2: 135.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 135.27,
    x2: 542.54,
    y2: 135.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 135.27,
    x2: 543.42,
    y2: 135.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 156.99,
    x2: 315.86,
    y2: 156.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 156.99,
    x2: 542.54,
    y2: 156.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 156.99,
    x2: 543.42,
    y2: 156.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 315.86,
    y1: 178.72,
    x2: 315.86,
    y2: 178.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.61,
    y1: 178.72,
    x2: 542.54,
    y2: 178.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 543.42,
    y1: 178.72,
    x2: 543.42,
    y2: 178.72
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M544.09,102.99s-1.84-2.14-2-1.88-.44,1.66-.67,2.9-.76,3.4-1.54,3.42-1.22-.37-2-.5-1.4.3-1.93.78-1.06.76-2.05-.27-1.91-2.85-2.5-4.62c-.58-1.77-1.24-1.89-1.79-2.12s-.92-.9-1.12-1.7-.5-2.99-.99-4.97-1.4-.83-1.82-.21-1.45,2.8-1.95,3.47-2.07,2.23-2.57,1.89-.97-1.68-1.56-2.64-1.13-.37-1.73.16-.97.44-1.43-.21-1.03-2.05-1.66-2.05-.97.62-1.56,1.36-1.52,2.02-2.48,2.04-1.45-.65-1.93-1.52-.69-1.91-1.91-3.4-2.66-.11-3.06.76-1.01,2.55-1.84,2.58-1.22-.78-1.73-1.86-1.19-3.2-1.7-3.68-.81-.71-1.77-1.98-1.79-.74-2.34-.11-.89,2.18-1.38,2.19-.44-.23-1.61-2.53-2.18,0-2.62,1.38-1.17,2.99-1.77,2.99-1.54-1.72-2.6-1.73-1.63,1.24-2.12,2.3-.96,3.03-1.82,3.08-1.04-.64-1.45-1.66-.96-4.37-1.59-6.97c-.64-2.6-1.95.51-2.92,2.18s-1.61,2.53-2.18,2.55-1.29-1.12-1.75-1.12-.59.26-.89,1.17-.27,1.28-1.11,1.99-1.11-.27-1.28-.95-.84-2.57-2.23-4.15-2.03-4.46-2.9-7.36c-.88-2.9-1.28-2.33-1.62-1.76s-.41,1.82-1.15,1.82-.88-.44-1.62-2.94-1.62-1.42-2.16-.24-1.05,3.14-1.79,5.77-2.16,2.13-3.17,1.59-2.13,1.08-3.21,2.84-1.65,2.43-2.63,2.5-1.35-.27-2.3-1.42-1.25-3.11-1.99-5.3-1.42-1.62-2.06-.57-1.42,2.94-1.92,3.88-1.22.81-1.99.07-.98-1.92-1.52-3.24-.81-1.52-1.45-2.19-1.05-1.08-2.23-1.59-.98-.61-2.16-2.26-1.62.68-1.99,2.84-.84,3.98-1.72,5.3-.91,1.65-1.52,4.02-1.65,1.22-2.09.17-.74-2.87-.95-3.88-.64-2.8-1.69-2.53-1.59,2.94-2.26,5.4-1.38.64-1.92-.68-1.76-.27-2.03.91-.71,2.53-1.32,3.92c-.61,1.38-2.7,7.53-3.24,7.6s-1.01-.54-1.55-.3-.98,2.57-1.28,4.05-.84,5.91-1.38,6.95-1.79,1.76-2.77,1.32-1.49-2.67-2.23-4.42c-.74-1.76-1.42-1.76-2.03-1.76s-.71-.2-1.28-1.01-1.08-1.01-1.52-.37-.74,2.33-1.01,3.92c-.27,1.59-.71,3.04-1.35,3.07s-.37-.44-1.15-.14-1.62,2.36-2.19,4.29-1.59,5.7-2.03,7.43c-.44,1.72-1.01,2.6-1.79,2.6s-2.26-1.22-2.97-1.01-1.62,1.86-2.26,4.39-.98,3.07-1.59,3.07-1.08-.68-1.62-.68-1.08.57-1.55.64-.95-.74-1.76,0-1.15,2.09-1.92,2.72-1.59,1.8-1.92,2.37-.24,1.15-1.32,2.13-1.72,1.01-2.3.61-1.49-2.36-2.57-4.29c-1.08-1.92-2.13,0-2.5,1.05s-.68,2.63-1.32,2.63-.84-.98-1.65-2.33-1.76.07-2.23.71-1.72,6.21-2.16,9.25c-.44,3.04-.74,3.75-1.52,3.95s-1.01-.34-1.38-.71-1.01-.37-1.28-.64-.71-1.05-1.62-.44-1.01,2.16-1.35,3.92-1.01,5.43-1.69,6.72-1.59.2-2.19-.34-1.18-.84-1.65-.91-.68.14-1.25.1-1.08-.24-1.79-.24-1.08.51-1.55,1.65-1.15,1.82-1.76,1.89-.81-.17-1.25-.2-.91.24-1.32.24-1.18-.44-1.49-.44-.81.24-1.45.2-1.01-.88-1.55-1.99-1.28-.68-1.52-.14-1.38,3.48-2.03,3.48-1.01-1.01-1.38-1.05-1.25.37-1.25.37v16.34h225.04v-77.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.06,164.33s.88-.41,1.25-.37.74,1.05,1.38,1.05,1.79-2.94,2.03-3.48.98-.98,1.52.14.91,1.96,1.55,1.99,1.15-.2,1.45-.2,1.08.44,1.49.44.88-.27,1.32-.24.64.27,1.25.2,1.28-.74,1.76-1.89.84-1.65,1.55-1.65,1.22.2,1.79.24.78-.17,1.25-.1,1.05.37,1.65.91,1.52,1.62,2.19.34,1.35-4.96,1.69-6.72.44-3.31,1.35-3.92,1.35.17,1.62.44.91.27,1.28.64.61.91,1.38.71,1.08-.91,1.52-3.95c.44-3.04,1.69-8.61,2.16-9.25s1.42-2.06,2.23-.71,1.01,2.33,1.65,2.33.95-1.59,1.32-2.63,1.42-2.97,2.5-1.05c1.08,1.92,1.99,3.88,2.57,4.29s1.22.37,2.3-.61.98-1.55,1.32-2.13,1.15-1.74,1.92-2.37,1.11-1.98,1.92-2.72,1.28.07,1.76,0,1.01-.64,1.55-.64,1.01.68,1.62.68.95-.54,1.59-3.07,1.55-4.19,2.26-4.39,2.19,1.01,2.97,1.01,1.35-.88,1.79-2.6c.44-1.72,1.45-5.5,2.03-7.43s1.42-3.98,2.19-4.29.51.17,1.15.14,1.08-1.49,1.35-3.07c.27-1.59.57-3.27,1.01-3.92s.95-.44,1.52.37.68,1.01,1.28,1.01,1.28,0,2.03,1.76c.74,1.76,1.25,3.98,2.23,4.42s2.23-.27,2.77-1.32,1.08-5.47,1.38-6.95.74-3.81,1.28-4.05,1.01.37,1.55.3,2.63-6.21,3.24-7.6c.61-1.38,1.05-2.73,1.32-3.92s1.49-2.23,2.03-.91,1.25,3.14,1.92.68,1.22-5.13,2.26-5.4,1.49,1.52,1.69,2.53.51,2.84.95,3.88,1.49,2.19,2.09-.17.64-2.7,1.52-4.02,1.35-3.14,1.72-5.3.81-4.49,1.99-2.84.98,1.76,2.16,2.26,1.59.91,2.23,1.59.91.88,1.45,2.19.74,2.5,1.52,3.24,1.49.88,1.99-.07,1.28-2.84,1.92-3.88,1.32-1.62,2.06.57,1.05,4.15,1.99,5.3,1.32,1.49,2.3,1.42,1.55-.74,2.63-2.5,2.19-3.38,3.21-2.84,2.43,1.05,3.17-1.59,1.25-4.59,1.79-5.77,1.42-2.26,2.16.24.88,2.94,1.62,2.94.81-1.25,1.15-1.82.74-1.15,1.62,1.76c.88,2.9,1.52,5.77,2.9,7.36s2.06,3.48,2.23,4.15.44,1.65,1.28.95.81-1.08,1.11-1.99.43-1.17.89-1.17,1.19,1.13,1.75,1.12,1.2-.89,2.18-2.55,2.28-4.78,2.92-2.18c.64,2.6,1.19,5.95,1.59,6.97s.58,1.72,1.45,1.66,1.33-2.02,1.82-3.08,1.06-2.32,2.12-2.3,2,1.73,2.6,1.73,1.33-1.61,1.77-2.99,1.45-3.68,2.62-1.38,1.12,2.55,1.61,2.53.83-1.56,1.38-2.19,1.38-1.17,2.34.11,1.26,1.5,1.77,1.98,1.19,2.6,1.7,3.68.9,1.89,1.73,1.86,1.43-1.72,1.84-2.58,1.84-2.25,3.06-.76,1.43,2.53,1.91,3.4.97,1.54,1.93,1.52,1.89-1.29,2.48-2.04.92-1.36,1.56-1.36,1.2,1.4,1.66,2.05.83.74,1.43.21,1.15-1.12,1.73-.16,1.06,2.3,1.56,2.64,2.07-1.22,2.57-1.89,1.52-2.85,1.95-3.47,1.33-1.77,1.82.21.8,4.18.99,4.97.57,1.47,1.12,1.7,1.2.35,1.79,2.12c.58,1.77,1.5,3.59,2.5,4.62s1.52.74,2.05.27,1.15-.9,1.93-.78,1.22.51,2,.5,1.31-2.18,1.54-3.42.51-2.64.67-2.9,2,1.88,2,1.88"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 40.96,
    y: 55.15,
    width: 127.57,
    height: 127.57,
    rx: 2.16,
    ry: 2.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,60.18h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-25.43 101.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,72.67h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-37.91 113.61) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,84.31h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-49.56 125.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,97.09h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-62.34 138.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,109.18h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-74.43 150.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,121.82h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-87.07 162.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,133.85h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-99.1 174.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,146.52h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-111.77 187.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,160.14h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-125.39 201.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.85,172.81h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z",
    transform: "translate(-138.05 213.75) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,56.7h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(111.83 231.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,68.47h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(100.06 243.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,80.24h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(88.29 254.97) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,92.02h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(76.52 266.74) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,102.05h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(66.48 276.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,111.66h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(56.87 286.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,120.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(47.82 295.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,129.96h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(38.58 304.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,139.11h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(29.42 313.83) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,150.88h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(17.65 325.61) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,174.43h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(-5.89 349.15) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.94,162.65h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z",
    transform: "translate(5.88 337.38) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M43.64,48.87h0c.96,0,1.74.78,1.74,1.74v5.14s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-5.14c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M57.19,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M70.73,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M84.27,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M97.82,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.36,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M124.9,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M138.44,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M151.99,48.87h0c.96,0,1.74.78,1.74,1.74v4.4s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-4.4c0-.96.78-1.74,1.74-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M165.53,48.87h0c.96,0,1.74.78,1.74,1.74v5.11s-.02.05-.05.05h-3.38s-.05-.02-.05-.05v-5.11c0-.96.78-1.74,1.74-1.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M41.95,182.01h3.38s.05.02.05.05v5.1c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-5.1s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M55.53,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M69.11,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.68,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.26,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M109.84,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M123.41,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.99,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.56,182.71h3.38s.05.02.05.05v4.4c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-4.4s.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M164.14,182.04h3.38s.05.02.05.05v5.08c0,.96-.78,1.74-1.74,1.74h0c-.96,0-1.74-.78-1.74-1.74v-5.08s.02-.05.05-.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsOnboardingOpener);
export default __webpack_public_path__ + "static/media/LabsOnboardingOpener.1f3240f4ab5222f683de903278bbbb5a.svg";
export { ForwardRef as ReactComponent };